function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: -245,
  y: -191,
  width: 714,
  height: 584,
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.29289 14.1924C3.90237 13.8019 3.90237 13.1687 4.29289 12.7782L12.7782 4.29289C13.1687 3.90237 13.8019 3.90237 14.1924 4.29289C14.5829 4.68342 14.5829 5.31658 14.1924 5.70711L5.70711 14.1924C5.31658 14.5829 4.68342 14.5829 4.29289 14.1924Z",
  fill: "#E67002"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.1924 14.1924C13.8019 14.5829 13.1687 14.5829 12.7782 14.1924L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L14.1924 12.7782C14.5829 13.1687 14.5829 13.8019 14.1924 14.1924Z",
  fill: "#E67002"
});

var SvgTxError = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTxError, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tx-error.7f98e58a.svg";
export { ForwardRef as ReactComponent };